import startsWith from 'lodash/startsWith';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Column, Columns } from '../components';
import { withComponents } from '../components/Context';
import ResizableIframe from '../components/ResizableIframe';
import { withEdit } from '../Context';
import { replaceValues } from '../utils';
import { extractUTM, urlJoinParams } from '../utils/url';
import BaseSection from './BaseSection';
import './iframe-section.scss';

function isAppCraftUrl(url, urlType) {
  if (urlType === 'appcraft') return true;
  return (
    startsWith(url, 'https://static.appcraft.events/live') ||
    startsWith(url, 'https://api.appcraft.events/grade/html')
  );
}

function isRegistrationUrl(url, urlType) {
  if (urlType === 'registration') return true;
  return startsWith(url, 'https://app.appcraft.events/register');
}

function urlJoinUnescaped(url, params) {
  return urlJoinParams(url, params).replace(/%7B/g, '{').replace(/%7D/g, '}');
}

export function generateIframeUrl(url, urlType) {
  // eslint-disable-next-line no-restricted-globals
  if (isRegistrationUrl(url, urlType) && typeof window !== 'undefined') {
    // eslint-disable-next-line no-restricted-globals
    const params = extractUTM(window.location.search);
    // eslint-disable-next-line no-restricted-globals
    if (!url.includes('u=') && window.__DATA__.user?._id) {
      params.u = '{user._id}';
    }
    return urlJoinUnescaped(url, params);
  }
  if (isAppCraftUrl(url, urlType)) {
    // Auto-inject params if needed...
    if (!url.includes('userId=')) {
      return urlJoinUnescaped(url, {
        userId: '{user._id}',
        firstName: '{user.firstName}',
        lastName: '{user.lastName}',
        thumbnail: '{user.thumbnail.uri}',
      });
    }
  }
  return url;
}

class IFrameSection extends PureComponent {
  renderContents() {
    const {
      source,
      iframe,
      iframePosition,
      columnsSize,
      text,
      components,
      hasAutoResize,
      urlType,
    } = this.props;
    const url = replaceValues(generateIframeUrl(source, urlType));

    const { RichText } = components;

    // iframe key used to force refresh iframe/reload when url or hasAutoResize changes
    const iframeEl = (
      <ResizableIframe
        src={url}
        autoResize={hasAutoResize}
        allowFullScreen
        allow="camera;microphone;fullscreen"
        {...iframe}
      />
    );

    if (iframePosition === 'fullpage') return iframeEl;

    // Else left/right
    return (
      <Columns isCentered centerVertically>
        {iframePosition === 'left' && <Column className={columnsSize}>{iframeEl}</Column>}
        <Column>
          <RichText html={text} name="text" placeholder="Texte" />
        </Column>
        {iframePosition === 'right' && <Column className={columnsSize}>{iframeEl}</Column>}
      </Columns>
    );
  }

  render() {
    const { source, iframe, iframePosition, ...props } = this.props;

    return (
      <BaseSection {...props} block={this.props}>
        {!source && (
          <div style={{ padding: 32 }}>
            Paramétrez l'url du formulaire dans les options de droite
          </div>
        )}
        {this.renderContents()}
      </BaseSection>
    );
  }
}

IFrameSection.defaultProps = {
  columnsSize: 'is-half',
  source: '',
  iframePosition: 'fullpage',
  hasAutoResize: true,
  iframe: {},
  isPreview: false,
  text: '',
  urlType: undefined,
};

IFrameSection.propTypes = {
  columnsSize: PropTypes.string,
  hasAutoResize: PropTypes.bool,
  components: PropTypes.shape({
    RichText: PropTypes.elementType,
  }).isRequired,
  iframe: PropTypes.shape({
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  iframePosition: PropTypes.oneOf(['left', 'right', 'fullpage']),
  isPreview: PropTypes.bool,
  source: PropTypes.string,
  text: PropTypes.string,
  urlType: PropTypes.oneOf(['registration', 'appcraft']),
};

export default withEdit(withComponents(IFrameSection));
